// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import AppInfoComponentResourceViewModel from '../../../../viewModel/resource/AppInfoComponentResourceViewModel';
import AppInfoResourceViewModel from '../../../../viewModel/resource/AppInfoResourceViewModel';
import AppInfoResourceDTO from '../../dto/resource/AppInfoResourceDTO';

export default abstract class AppInfoResourceModel extends BaseModel<AppInfoResourceDTO> {
  /**
  */
  get title() { return this.dto.title; }
  set title(value) { this.dto.title = value; }
  /**
  */
  get version() { return this.dto.version; }
  set version(value) { this.dto.version = value; }
  /**
  */
  get healthEndpoint() { return this.dto.healthEndpoint; }
  set healthEndpoint(value) { this.dto.healthEndpoint = value; }
  /**
  */
  get environment() { return this.dto.environment; }
  set environment(value) { this.dto.environment = value; }
  /**
  */
  get components() { return this.getArrayModels(() => this.dto.components, AppInfoComponentResourceViewModel)!; }
  set components(value) { this.setArrayModels(() => this.dto.components, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.title = qs.title;
    this.dto.version = qs.version;
    this.dto.healthEndpoint = qs.healthendpoint;
    this.dto.environment = qs.environment;
  }
}
